import i18next from '@betty/i18n';
import en from './en.json';

i18next.addResources('en', 'games', en);

declare global {
  interface RegisteredLocales {
    games: typeof en;
  }
}
